import { Button } from "@mui/material";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../../../app/hooks";
import { EstimatedProcedure } from "../../../../../../services/verifyService/model/verification/EstimatedProcedure";
import { addProcedure, resetCodeSetMatches } from "../../../../../../services/verifyService/model/verification/VerificationSlice";
import { toggleProcedureCodeSetMatching } from "../../../../../../app/slices/VerificationModuleSlice";
import { CodeSetMatch, ProcedureCodeSetMatch } from "../../../../specs/codeSets/ProcedureCodeSetMatch";
import { forEach } from "lodash";

interface ApplyCodeSetsProps {
  selectedCodeSets: CodeSetMatch[];
}

function ApplyCodeSets({ selectedCodeSets = [] }: ApplyCodeSetsProps) {
  const dispatch = useAppDispatch();
  const verification = useAppSelector(
    (state) => state.verification.verification
  );
  
  const add = (code: string, description: string) => {
    const estimatedProc = new EstimatedProcedure(code, description);
    dispatch(addProcedure(estimatedProc));
  };
  
  const handleSave = () => {
    dispatch(toggleProcedureCodeSetMatching());
    
    // For each selected code set match, add the additional procedures
    if (selectedCodeSets.length > 0) {
      selectedCodeSets.forEach((match) => {
        if (match) {
          // Get procedures to add for this match
          const proceduresToAdd = new ProcedureCodeSetMatch().getProceduresToAdd(match, verification.procedures || []);
          
          // Add each procedure
          forEach(proceduresToAdd, (proc) => {
            if (proc?.code && proc.description) {
              add(proc.code, proc.description);
            }
          });
        }
      });
    }
    
    dispatch(resetCodeSetMatches());
  };
  
  return (
    <React.Fragment>
      <Button
        variant="contained"
        color="primary"
        size="small"
        disabled={selectedCodeSets.length === 0}
        onClick={() => {
          handleSave();
        }}
      >
        Add Codes
      </Button>
    </React.Fragment>
  );
}

export { ApplyCodeSets };
